import Stack, { StackProps } from '@liquidweb-dev/undercurrent/Stack';
import Typography from '@liquidweb-dev/undercurrent/Typography';
import VenetianMaskIcon from '@liquidweb-dev/undercurrent/icons/lucide/VenetianMask';

import { useAuth } from 'react-oidc-context';

const MasqueradeNote = (props: StackProps) => {
	const { user } = useAuth();

	if (!user?.profile?.masquerade) {
		return null;
	}

	return (
		<Stack
			direction="row"
			spacing={100}
			paddingX={200}
			paddingTop={100}
			paddingBottom={100}
			justifyContent="center"
			alignItems="center"
			bgcolor={({ vars }) => vars.palette.uc.highlight.bg.main}
			sx={({ borderRadius }) => ({
				borderTopLeftRadius: borderRadius.roundedSm,
				borderTopRightRadius: borderRadius.roundedSm,
			})}
			{...props}
		>
			<VenetianMaskIcon
				sx={({ size, vars }) => ({
					color: vars.palette.uc.highlight.icon.main,
					width: size.sm,
					height: size.sm,
				})}
			/>
			<Typography variant="body-sm">Masquerade mode active</Typography>
		</Stack>
	);
};

export default MasqueradeNote;
